import Swiper, { Navigation, EffectFade } from 'swiper';
import { isAtLeast } from '../utils/_breakpoints.js';

class mPlpQuickLinks extends HTMLDivElement {
    constructor() {
        super();
        this.sliderSize = {};
        this.slider = null;
        this.sliderInitialised = false;
        this.container = this.querySelector('.swiper-container');
        this.wrapper = this.querySelector('.swiper-wrapper');
        this.navPrev = this.querySelector('.swiper-button-prev');
        this.navNext = this.querySelector('.swiper-button-next');
        this.slides = this.querySelectorAll('.swiper .swiper-slide');
    }

    connectedCallback() {
        this.initMobileSlider();
    }

    initMobileSlider() {
        if (this.slider !== null) {
            this.slider.destroy(true, true);
            this.slider = null;
        }

        if (!isAtLeast('md')) {
            this.initSlider();
        } else {
            const style = getComputedStyle(this);
            const paddingLeft = parseFloat(style.paddingLeft);
            const paddingRight = parseFloat(style.paddingRight);
            const realClientWidth = this.wrapper.clientWidth - paddingLeft - paddingRight;

            if (this.wrapper.scrollWidth > realClientWidth) {
                this.initSlider();
                this.classList.remove('no-slider');
            } else {
                this.classList.add('no-slider');
            }
        }
    }

    initSlider() {
        let activeIndex = 0;
        let activeSlide;
        const previousArrowsLabel = this.querySelector('.swiper-button-prev').ariaLabel;
        const nextArrowsLabel = this.querySelector('.swiper-button-next').ariaLabel;

        this.slides.forEach((slide, index) => {
            if (slide.classList.contains('active')) {
                activeIndex = index;
                activeSlide = slide;
            }
        });

        this.slider = new Swiper(this.container, {
            modules: [Navigation, EffectFade],
            allowTouchMove: true,
            initialSlide: 0,
            fadeEffect: { crossFade: true },
            watchSlidesProgress: true,
            a11y: {
                enabled: true,
                prevSlideMessage: previousArrowsLabel,
                nextSlideMessage: nextArrowsLabel,
            },
            on: {
                init: this.updateSlidesA11y,
                slideChange: this.updateSlidesA11y,
                resize: this.updateSlidesA11y,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            slidesPerView: 'auto',
        });
    }

    updateSlidesA11y(swiperInstance) {
        swiperInstance.slides.forEach((slide) => {
            const isVisible = slide.classList.contains('swiper-slide-fully-visible')
                            || slide.classList.contains('swiper-slide-visible');

            if (isVisible) {
                slide.removeAttribute('tabindex');
                slide.removeAttribute('aria-hidden');
            } else {
                slide.setAttribute('tabindex', '-1');
                slide.setAttribute('aria-hidden', 'true');
            }
        });
    }
}

customElements.define('m-plp-quick-links', mPlpQuickLinks, {
    extends: 'div',
});
